import React, { FormEvent, ChangeEvent } from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";

import ToolbarMenuItem from "../ToolbarMenuItem";
import ViewToolbar from "../ViewToolbar";
import OverflowMenuItem from "../OverflowMenuItem";

import { V2 } from "../../Api";
import { formatDateLocal, formatName } from "../../Utilities";
import { IAuthProps } from "../AuthContext";
import withAuth from "../withAuth";
import withTitle, { IViewTitleProps } from "../withTitle";

import "../../blocks.css";
import "../../button.css";
import "../../table.css";
import "../viewer.css";
import DeletionConfirmationDialog from "../DeletionConfirmationDialog";
import NoteBox from "../NoteBox";
import HasRight from "../HasRight";

interface IConsultDetailsViewProps extends RouteComponentProps<any>, IViewTitleProps, IAuthProps {

}

interface IConsultDetailsViewState {
    isLoading: boolean | string;
    isSubmitting: boolean | string;

    isDeletionModalOpen: boolean;

    isModalOpen: boolean;
    modalLoading: boolean | string;

    consult: any;
}

class ConsultDetailsView extends React.Component<IConsultDetailsViewProps, IConsultDetailsViewState> {
    constructor(props: Readonly<IConsultDetailsViewProps>) {
        super(props);

        this.state = {
            isLoading: true,
            isSubmitting: false,

            isDeletionModalOpen: false,

            isModalOpen: false,
            modalLoading: false,

            consult: {},
        };

        this.deleteItem = this.deleteItem.bind(this);
        this.realDeleteItem = this.realDeleteItem.bind(this);
        this.closeDeletionModal = this.closeDeletionModal.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.dialogInputChanged = this.dialogInputChanged.bind(this);
        this.createNewNote = this.createNewNote.bind(this);
        this.deleteNote = this.deleteNote.bind(this);
    }

    public async componentDidMount() {
        try {
            this.setState({
                isLoading: true,
            })

            const consult = await V2.get<any>(`consult/${this.props.match.params.id}`);

            if (consult.notes) {
                consult.notes.forEach((note: any) => {
                    note.author = formatName(note.employee.name);
                });
            }

            this.setState({
                isLoading: false,
                consult,
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Could not load data"
            });
        }
    }

    public render() {
        if (this.state.isLoading === true) {
            return (
                <div className="spinner-full-root">
                    <div className="spinner lds-dual-ring-big" />
                </div>
            );
        }

        if (typeof this.state.isLoading === "string") {
            return (
                <div className="viewer-root">
                    <div className="error-box">{this.state.isLoading}</div>
                </div>
            );
        }

        return (
            <div className="viewer-root with-actionbar">
                <ViewToolbar>
                    <OverflowMenuItem>
                        <ToolbarMenuItem right="appt:con:write" condition={this.state.consult.status === 0 || this.state.consult.status === 2}>
                            <button type="button" onClick={() => this.setStatus(3)}><i className="icon-check" /><span>Good to go</span></button>
                        </ToolbarMenuItem>
                        <ToolbarMenuItem right="appt:con:write" condition={this.state.consult.status === 0 || this.state.consult.status === 2}>
                            <button type="button" onClick={() => this.setStatus(2)}><i className="icon-clock-o" /><span>Contact again later</span></button>
                        </ToolbarMenuItem>
                        <ToolbarMenuItem right="appt:con:write" condition={this.state.consult.status === 0 || this.state.consult.status === 2}>
                            <button type="button" onClick={() => this.setStatus(1)}><i className="icon-ban" /><span>Does not want</span></button>
                        </ToolbarMenuItem>
                        <ToolbarMenuItem right="appt:con:delete">
                            <button type="button" onClick={this.deleteItem}><i className="icon-trash" /><span>Delete</span></button>
                        </ToolbarMenuItem>
                    </OverflowMenuItem>
                </ViewToolbar>
                <DeletionConfirmationDialog isOpen={this.state.isDeletionModalOpen} onRequestClose={this.closeDeletionModal} onConfirm={this.realDeleteItem} onSuccess={this.handleDeleteSuccess} />
                {/*this.state.isModalOpen
                    ? <ReactModal
                        isOpen={this.state.isModalOpen} onRequestClose={this.closeModal}
                        overlayClassName="modal-overlay" className="modal-content" portalClassName="modal-portal"
                        bodyOpenClassName="modal-open"
                        contentLabel="Send to Consultation dialog">
                        <form className="input-form" onSubmit={this.realSendToConsultation}>
                            <section className="info-block">
                                <header>
                                    <h3>Send to Consultation</h3>
                                </header>
                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-consult-note">Note</label>
                                        <textarea id="frm-consult-note" className="input-textarea-medium" name="consultNote" value={this.state.consultNote} onChange={this.dialogInputChanged} autoComplete="off_please_chrome" />
                                    </div>
                                </section>
                                <br />
                                {
                                    this.state.modalLoading === true
                                        ? <Fragment><div className="spinner lds-dual-ring" /><br /></Fragment>
                                        : typeof this.state.modalLoading === "string"
                                            ? <Fragment><span className="error-text">{this.state.modalLoading}</span><br /></Fragment>
                                            : ""
                                }
                                <div className="action-panel-dialog">
                                    <button type="submit" className="button green push-right" disabled={!this.state.consultNote}>Send</button>
                                    <button type="button" className="button" onClick={this.closeModal}>Close</button>
                                </div>
                            </section>
                        </form>
                    </ReactModal>
                    : null*/}
                <div className="column-root">
                    <section className="info-block">
                        <header>
                            <h3>Contact Information</h3>
                        </header>
                        <dl className="info-list">
                            <div className="info-list-row">
                                <div>
                                    <dt>Name</dt>
                                    <dd>{formatName(this.state.consult.patient.name)}</dd>
                                </div>
                                <div>
                                    <dt>Birthdate</dt>
                                    <dd>{formatDateLocal(this.state.consult.patient.birthDate)}</dd>
                                </div>
                            </div>

                            {/*
                            <dt>Address</dt>
                            <dd>{survey.address.street}</dd>
                            <dd>{`${survey.address.city}, ${survey.address.state} ${survey.address.zip}`}</dd>
                            */}

                            <div className="info-list-row">
                                <div>
                                    <dt>Phone number</dt>
                                    <dd><a href={`tel:${this.state.consult.patient.phone}`}>{this.formatPhone(this.state.consult.patient.phone)}</a></dd>
                                </div>
                                <div>
                                    <dt>Insurance</dt>
                                    <dd>{this.state.consult.patient.insuranceProvider}</dd>
                                </div>
                            </div>
                            <div>
                                <dt>Email</dt>
                                <dd>{this.state.consult.patient.email ? <a href={`mailto:${this.state.consult.patient.email}`}>{this.state.consult.patient.email}</a> : "N/A"}</dd>
                            </div>

                            <div className="info-list-row">
                                {
                                    this.state.consult.surveyId
                                        ? <div>
                                            <dt>Source</dt>
                                            <dd>Questionnaire. <Link to={`/surveys/${this.state.consult.surveyId}`}>View</Link></dd>
                                            {this.state.consult.referrer
                                                ? <dd><small>Referred by {formatName(this.state.consult.referrer.name)}</small></dd>
                                                : null}
                                        </div>
                                        : null}
                                <div>
                                    <dt>Sex</dt>
                                    <dd>{this.sexToString(this.state.consult.patient.sex)}</dd>
                                </div>
                            </div>
                        </dl>
                    </section>
                    <section className="info-block">
                        <header>
                            <h3>Notes</h3>
                        </header>

                        <NoteBox notes={this.state.consult.notes} displayName={this.props.authContext.user.displayName} onNewNote={this.createNewNote} onNoteDelete={this.deleteNote} allowDeletion={this.props.authContext.hasRight("appt:con:delete")} />
                    </section>
                </div>
                &nbsp;
                {
                    this.state.isSubmitting === true
                        ? <div className="spinner lds-dual-ring" />
                        : typeof this.state.isSubmitting === "string"
                            ? <div className="error-text">{this.state.isSubmitting}</div>
                            : null
                }
                <div className="action-panel">
                    {
                        /*this.state.survey.appointmentId
                                ? <HasRight right="appt:read"><Link className="button push-right text-with-icon" to={{ pathname: `/appointments/${this.state.survey.appointmentId}` }}> <i className="icon-calendar" /><span>View Appointment</span></Link></HasRight>*/
                        <HasRight right="appt:create"><Link className="button push-right text-with-icon" to={{ pathname: "/appointments/create", state: { consult: this.state.consult } }}> <i className="icon-plus" /><span>New Appointment</span></Link></HasRight>
                    }
                </div>
            </div>
        );
    }

    private formatPhone(phone: string) {
        phone = "1" + phone;
        const match = phone.match(/[+]?(\d{1,3})?(\d{3})(\d{3})(\d{4})$/);
        if (!match) {
            return phone;
        }

        return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
    }

    private deleteItem() {
        this.setState({
            isDeletionModalOpen: true
        });
    }

    private closeDeletionModal() {
        this.setState({
            isDeletionModalOpen: false
        });
    }

    private async realDeleteItem(e?: FormEvent) {
        if (e) {
            e.preventDefault();
        }

        await V2.delete(`consult/${this.state.consult.id}`);
    }

    private handleDeleteSuccess() {
        this.props.history.goBack();
    }

    private dialogInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) {
        const name = e.currentTarget.name;
        const value: string | boolean | any = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState({
            [name]: value
        } as any);
    }

    private async createNewNote(body: string) {
        const newNote = await V2.post<any>(`consult/${this.state.consult.id}/notes`, { body });
        newNote.author = formatName(newNote.employee.name);

        this.setState(s => {
            s.consult.notes.push(newNote);

            return { consult: s.consult };
        });
    }

    private async deleteNote(index: number) {
        const noteId = this.state.consult.notes[index] && this.state.consult.notes[index].id;
        if (noteId === undefined) {
            return;
        }

        await V2.delete(`consult/${this.state.consult.id}/notes/${noteId}`);

        this.setState(s => {
            s.consult.notes.splice(index, 1);

            return { consult: s.consult };
        });
    }

    private async setStatus(status: number) {
        try {
            this.setState({
                isSubmitting: true
            });

            await V2.patch(`consult/${this.state.consult.id}`, { status });

            this.props.history.goBack();
        }
        catch (e) {
            this.setState({
                isSubmitting: e.message || e || "Could not save changes"
            });
        }
    }

    private sexToString(sex: string) {
        switch (sex) {
            case "f":
            case "F": return "Female";
            case "m":
            case "M": return "Male";
            case null:
            case undefined: return "Unspecified";
            default: return `Unknown (${sex})`;
        }
    }
}

export default withTitle("Pellet Consultation Details", withAuth(ConsultDetailsView));
